define([
    'text!index2024-buyChannel/component/page-content.html',
    'index2024-buyChannel/common/api',
    'jquery',
    '../common/utils',
    'inView',
    'index2024-buyChannel/component/item-design',
    '../../../../vendor/slick/slick.js',
    'css!index2024-buyChannel/component/page-content.css',
    'css!vendor/slick/slick.css',
    'css!vendor/slick/slick-theme.css',
    'css!index2020/component/image-slick.css'
], function(
    tpl,
    Api,
    $,
    Utils,
    inView,
    ItemDesign
){
    return {
        template: tpl,
        components: {
            ItemDesign: ItemDesign
        },
        data: function(){
            return {
                onlineList: [
                    {id: '100',place: '淘宝',name: '梵几天猫旗舰店',btn: '点击进入天猫',link: 'tianmao'},
                    {id: '101',place: '',name: 'by fnji 淘宝店',btn: '点击进入店铺',link: 'taobao'},
                    {id: '102',place: '小程序',name: '梵几官方小程序商城',btn: '',link: ''},
                ],
                onlineListEn: [
                    {id: '100',place: '',name: 'FNJI Tmall Shop',btn: 'Click to enter the store',link: 'tianmao'},
                    {id: '101',place: '',name: 'FNJI Taobao Shop',btn: 'Click to enter the store',link: 'taobao'},
                    {id: '102',place: '',name: 'FNJI Wechat Shop',btn: '',link: ''},
                ],
                onlineIndex: [{num:2,theIndex:0},{num:1,theIndex:2}],//滚动
                shopList: [
                    {city: '北京',name: '梵几三里屯太古里店',link: '/exhibitionhall?id=2',place: '北京市三里屯太古里北区NLG-07、08',info: '10:00~22:00  |  010-84388131',img: 's20480_1709199849_7346.jpg'},
                    {city: '',name: '梵几颐堤港店',link: '/exhibitionhall?id=3',place: '北京市朝阳区酒仙桥路18号颐堤港LG50A梵几',info: '10:00~22:00  |  010-84176728',img: 's20480_1632628395_5424.png'},
                    {city: '',name: '「梵几客厅」国子监店（升级中）',link: '/exhibitionhall?id=4',place: '北京市东城区安定门内国子监街41号',info: '10:30~19:00  |  010-53672899',img: 's20480_1629778762_2844.png'},
                    // {city: '上海',name: '「梵几客厅」武康路店',place: '上海市徐汇区武康路近湖南路',info: '11:00~19:30（周一店休）  |  021-54961966',img: 's20480_1629778834_4482.png'},
                    {city: '上海',name: '梵几客厅武康路店',link: '/exhibitionhall?id=6',place: '上海市徐汇区武康路370号',info: '11:00～19:00｜021-54668987',img: 's20480_1718864994_4686.png'},
                    {city: '',name: '梵几上海前滩太古里店',link: '/exhibitionhall?id=5',place: '上海市浦东新区东育路500号前滩太古里石区4楼梵几',info: '10:00-22:00  |  021-61017656',img: 's20480_1709199693_2655.jpg'},
                    {city: '广州',name: '梵几广州粤海天地店',link: '/exhibitionhall?id=7',place: '广州市天河区珠江西路21号粤海天地L1梵几',info: '10:00-22:00  |  020-66837669',img: 's20480_1713005658_4806.jpg'},
                    // {city: '深圳',name: '梵几深业上城店',place: '深圳市福田区皇岗路5001号深业上城小镇L3层T3062铺-00L4层T4006铺',info: '10:00~22:00  |  0755-82799649',img: 's20480_1629778871_4586.png'},
                    // {city: '',name: '梵几万象天地快闪店',place: '深圳市南山市深南大道9668号万象天地LG层LG60店铺',info: '10:00~22:00  |  2021.3.20——2021.8.27',img: 's20480_1629778888_5579.png'},
                    {city: '深圳',name: '梵几万象前海店',link: '/exhibitionhall?id=8',place: '深圳市前海深港合作区南山街道桂湾四路169号万象前海购物中心L167——L267',info: '10:00~22:00  |  88986489',img: 's20480_1644804940_4680.jpg'},
                    {city: '',name: '梵几卓悦中心店',link: '/exhibitionhall?id=9',place: '深圳市福田区福田街道岗厦社区深南大道卓悦中心北区L1、L2层N124-N216-217号',info: '10:00~22:00  |  0755-61687786',img: 's20480_1644805198_8163.jpg'},
                    // {city: '成都',name: '梵几远洋太古里店',place: '成都市锦江区中纱帽街8号成都远洋太古里第二层2230a、2230b号商铺及其三层',info: '10:00~22:00  |  028-65100422',img: 's20480_1629778920_1077.png'},
                    {city: '杭州',name: '梵几留和路店',link: '/exhibitionhall?id=11',place: '杭州市西湖区留和路139号东信和创园15栋',info: '10:00~18:00  |  0571-88963099',img: 's20480_1629778937_2880.png'},
                    {city: '苏州',name: '梵几苏州诚品店',link: '/exhibitionhall?id=12',place: '苏州市诚品生活1F L107',info: '10:00~22:00  |  0512-67209366',img: 's20480_1629778952_1493.png'},
                    // {city: '',name: '梵几苏州春风里店',place: '苏州市相城区御窑路大悦春风里L1-29/30',info: '12:00~21:00  |  0512-83912386',img: 's20480_1709199528_2401.jpg'},
                    {city: '南京',name: '梵几南京金鹰世界店',link: '/exhibitionhall?id=14',place: '南京市建邺区应天大街888号金鹰世界2层',info: '10:00-22:00  |  025-58805881',img: 's20480_1629778971_2466.png'},
                    {city: '成都',name: '梵几成都富森店',link: '/exhibitionhall?id=15',place: '成都市高新区盛和二路18号成都富森美家居3号店（家具馆）2楼2117、2118、2119、2130',info: '周一-周五 10:00-18:00 周末或节假日：10:00-19:00  |  028-85358515',img: 's20480_1629778920_1077.png'}
                ],
                shopIndex: [
                    {num:3,theIndex:0},
                    {num:2,theIndex:3},
                    {num:1,theIndex:5},
                    {num:2,theIndex:6},
                    {num:1,theIndex:8},
                    {num:1,theIndex:9},
                    {num:1,theIndex:10},
                    {num:1,theIndex:11}
                ],
                onlineh: 0,
                shoph: 0,
                isOnline: true,
                isZh: true,
                isPC: true,
                lineNum: 1
            };
        },
        methods: {
            toTab: function(){
                console.log(111);
                var _this = this;
                var url = window.location.href;
                console.log(url);
                if(url.indexOf('tab=3')>-1){
                    _this.toScroll(3);
                }
            },

            initShopList: function () {
                var _this = this;
                Api.getShopListApi.ajax({lang:_this.$i18n.locale})
                    .done(function(data){
                        _this.shopList = data;
                        console.log(data)
                    });
            },
            init: function(){
                this.initShopList();
                var _this = this;
                _this.onlineh = $('.index2021-buyChannel-shopLine-item').eq(_this.onlineList.length-1).offset()['top']-84;
                _this.shoph = $('.index2021-buyChannel-shop-item').eq(0).offset()['top']-150;
                if($(window).width()<=750){
                    _this.isPC = false;
                    $('.fixed-menu').css({'display': 'none'});
                }else {
                    _this.isPC = true;
                }
                if(_this.$i18n.locale=='en'){
                    _this.isZh = false;
                    _this.onlineList = _this.onlineListEn;
                }else {
                    _this.isZh = true;
                }
            },
            toTianMao: function () {
                window.open('https://fanjijiaju.tmall.com','_blank');
            },
            getScroll: function () {
                var obj = this;
                var onlineChange = obj.onlineh;
                var scrollTop = $(window).scrollTop();
                if(onlineChange<=scrollTop){
                    // obj.isOnline = false;
                    $('.index2021-buyChannel-line1').css({width: '0',transtion: 'width 0.8s'});
                    if(obj.isPC){
                        // $('.index2021-buyChannel-line2').css({width: '104px',transtion: 'width 1.5s'});
                    }else {
                        // $('.index2021-buyChannel-line2').css({width: '155px',transtion: 'width 1.5s'});
                    }
                    obj.lineNum = 2;
                }else {
                    // obj.isOnline = true;
                    $('.index2021-buyChannel-line2').css({width: '0',transtion: 'width 0.8s'});
                    // $('.index2021-buyChannel-line1').css({width: '104px',transtion: 'width 1.5s'});
                    if(obj.isPC){
                        $('.index2021-buyChannel-line1').css({width: '104px',transtion: 'width 1.5s'});
                    }else {
                        $('.index2021-buyChannel-line1').css({width: '155px',transtion: 'width 1.5s'});
                    }
                    obj.lineNum = 1;
                }
                var scrollHeight = 360;
                var toHeight = 360;
                obj.onlineIndex.forEach(function (item,index) {
                    scrollHeight = toHeight;
                    toHeight = toHeight+item.num*99;
                    if(scrollHeight>=scrollTop){
                        $('.index2021-buyChannel-shopLine-item').eq(item.theIndex).find('.index2021-buyChannel-place-scroll').css({position:'relative',top:'0'});
                    }else if(toHeight-33>scrollTop&&scrollTop>scrollHeight){
                        // console.log(scrollHeight);
                        // console.log(scrollTop);
                        $('.index2021-buyChannel-shopLine-item').eq(item.theIndex).find('.index2021-buyChannel-place-scroll').css({position:'fixed',top:'150px'});
                    }else if(toHeight>scrollTop&&scrollTop>toHeight-33){
                        $('.index2021-buyChannel-shopLine-item').eq(item.theIndex).find('.index2021-buyChannel-place-scroll').css({position:'fixed',top:117-scrollTop+toHeight+'px'});
                    }else {
                        console.log(scrollTop);
                        $('.index2021-buyChannel-shopLine-item').eq(item.theIndex).find('.index2021-buyChannel-place-scroll').css({position:'fixed',top:117+'px'});
                    }
                });


                var shopHeight = obj.shoph;
                var toShopHeight = shopHeight;
                obj.shopIndex.forEach(function (items,indexs) {
                    shopHeight = toShopHeight;
                    toShopHeight = toShopHeight+items.num*256;
                    if(shopHeight>=scrollTop){
                        $('.index2021-buyChannel-shop-item').eq(items.theIndex).find('.index2021-buyChannel-city-scroll').css({position:'relative',top:'0'});
                    }else if(toShopHeight-33>scrollTop&&scrollTop>shopHeight){
                        $('.index2021-buyChannel-shop-item').eq(items.theIndex).find('.index2021-buyChannel-city-scroll').css({position:'fixed',top:'150px'});
                    }else if(toShopHeight>scrollTop&&scrollTop>toShopHeight-33){
                        $('.index2021-buyChannel-shop-item').eq(items.theIndex).find('.index2021-buyChannel-city-scroll').css({position:'fixed',top:117-scrollTop+toShopHeight+'px'});
                    }else {
                        $('.index2021-buyChannel-shop-item').eq(items.theIndex).find('.index2021-buyChannel-city-scroll').css({position:'fixed',top:117+'px'});
                    }
                });
            },
            toScroll: function(index){
                var toThePlace = 0;
                this.lineNum = index;
                if(index===1){
                    // toThePlace = $('#buyChannel-online').offset().top;
                    toThePlace = 0;
                }else if(index===3){
                    toThePlace = $('#buyChannel-procure').offset().top-300;
                }else {
                    // window.location.hash('#buyChannel-shop');
                    toThePlace = $('#buyChannel-shop').offset().top-300;
                }
                Utils.scrollTo(toThePlace);
            },
            toShop: function (link) {
                if(link=='tianmao'){
                    window.open('https://fanjijiaju.tmall.com','_blank');
                }else if(link=='taobao'){
                    window.open('https://shop444867519.taobao.com/?spm=a230r.7195193.1997079397.2.3e2a71d6az7bqM','_blank');
                }
            },
            toTheShops: function (link) {
                window.location.href = link;
            }
        },
        watch: {
            '$i18n.locale': function () {
                this.init();
            }
        },
        mounted: function(){
            this.toTab();
            this.init();
            // this.initAnimate();
            Utils.emitPageReady();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
            $(window).scroll(function () {
                obj.getScroll();
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./index2024-buyChannel/component/page-content.js
// module id = 343
// module chunks = 5